// extracted by mini-css-extract-plugin
export default {"link":"Formaciones_link__9h7D1","actions":"Formaciones_actions__8RuLS","ejercicio":"Formaciones_ejercicio__OSM+4","fab":"Formaciones_fab__yujcn"};